import styled from 'styled-components'

const Main = styled.section`
	padding-top: 150px;
	min-height: 300px;
	width: 100%;
	color: white;
	z-index: 2;

	@media (max-width: 768px) {
		padding-top: 100px;
		min-height: 300px;
		width: 100%;
		color: white;
		z-index: 2;
	}
`
export default Main
